<template>
    <v-card elevation="0" style="overflow: auto; border-radius: 8px">
        <v-card-title class="font14 pt-1 greyText font-weight-regular">
            <v-icon>mdi-cash-refund</v-icon>
            {{ $t('eventStats.gamePositions') }}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="6" v-if="positionFTRegular" class="text-center py-2">
                    <v-chip
                        outlined
                        :color="positionFTRegular > 0 ? 'tbGreen' : 'red'"
                        style="padding: 0 12px 0 0"
                        @click.stop="showGameGrid($const.EVENT_PERIOD_FT, positionFTRegular, positionFTCorners)"
                    >
                        <v-btn icon>
                            <FullTime :color="positionFTRegularColor" :size="32"></FullTime>
                        </v-btn>
                        {{ utils.getCurrencySymbol(user.currency) }}{{ positionFTRegular }}
                        <SoccerBall :color="positionFTRegularColor" :size="24" class="pl-2"></SoccerBall>
                    </v-chip>
                </v-col>
                <v-col cols="6" v-if="position1HRegular" class="text-center py-2">
                    <v-chip
                        outlined
                        :color="position1HRegular > 0 ? 'tbGreen' : 'red'"
                        style="padding: 0 12px 0 0"
                        @click.stop="showGameGrid($const.EVENT_PERIOD_1H, position1HRegular, position1HCorners)"
                    >
                        <v-btn icon>
                            <HalfTime :color="position1HRegularColor" :size="24"></HalfTime>
                        </v-btn>
                        {{ utils.getCurrencySymbol(user.currency) }}{{ position1HRegular }}

                        <SoccerBall :color="position1HRegularColor" :size="24" class="pl-2"></SoccerBall>
                    </v-chip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" v-if="positionFTCorners" class="text-center py-2">
                    <v-chip
                        outlined
                        :color="positionFTCorners > 0 ? 'tbGreen' : 'red'"
                        style="padding: 0 12px 0 0"
                        @click.stop="showGameGrid($const.EVENT_PERIOD_FT, positionFTRegular, positionFTCorners)"
                    >
                        <v-btn icon>
                            <FullTime :color="positionFTCornersColor" :size="32"></FullTime>
                        </v-btn>
                        {{ utils.getCurrencySymbol(user.currency) }}{{ positionFTCorners }}
                        <CornerFlag :color="positionFTCornersColor" :size="26" class="pl-2"></CornerFlag>
                    </v-chip>
                </v-col>
                <v-col cols="6" v-if="position1HCorners" class="text-center py-2">
                    <v-chip
                        outlined
                        :color="position1HCorners > 0 ? 'tbGreen' : 'red'"
                        style="padding: 0 12px 0 0"
                        @click.stop="showGameGrid($const.EVENT_PERIOD_1H, position1HRegular, position1HCorners)"
                    >
                        <v-btn icon>
                            <HalfTime :color="position1HCornersColor" :size="24"></HalfTime>
                        </v-btn>
                        {{ utils.getCurrencySymbol(user.currency) }}{{ position1HCorners }}
                        <CornerFlag :color="position1HCornersColor" :size="26" class="pl-2"></CornerFlag>
                    </v-chip>
                </v-col>
            </v-row>
        </v-card-text>
        <AppGrid ref="gameGrid" :width="870"></AppGrid>
    </v-card>
</template>

<style scoped></style>

<script>
    import AppEventStatsRow from 'Pages/core/event/EventStatsRow.vue';
    import AppGrid from '../grid/AppGrid';
    import SoccerBall from "Pages/core/icon/ball/SoccerBall.vue";
    import CornerFlag from "Pages/core/icon/corner/CornerFlag.vue";
    import FullTime from "Pages/core/icon/period/FullTime.vue";
    import HalfTime from "Pages/core/icon/period/HalfTime.vue";

    export default {
        name: 'app-eventPositionSidePanel',
        components: {FullTime, HalfTime, CornerFlag, SoccerBall, AppEventStatsRow, AppGrid },
        props: {
            tableHeight: {
                default: undefined,
                type: Number,
            },
            positionFTRegular: {
                default: null,
                type: String,
            },
            position1HRegular: {
                default: null,
                type: String,
            },
            positionFTCorners: {
                default: null,
                type: String,
            },
            position1HCorners: {
                default: null,
                type: String,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {};
        },

        methods: {
            isEmpty(value) {
                return _.isEmpty(value);
            },
            showGameGrid(periodTypeId, balanceRegular, balanceCorners) {
                let feedLine = { ...this.event, ...this.eventStats };
                const balance = (parseFloat(balanceRegular ?? 0) + parseFloat(balanceCorners ?? 0)).toFixed(2);
                if (feedLine.mId !== this.$const.DBALL_MARKET_LIVE) {
                    feedLine.sc = '0-0';
                    feedLine.cHome = 0;
                    feedLine.cAway = 0;
                } else {
                    feedLine.sc = feedLine.score;
                    feedLine.cHome = feedLine.corners_home;
                    feedLine.cAway = feedLine.corners_away;
                }
                this.$refs.gameGrid.$data.periodTypeId = periodTypeId;
                this.$refs.gameGrid.$data.feedLine = feedLine;
                this.$refs.gameGrid.$data.balance = balance;
                this.$refs.gameGrid.$refs.gameGridDialog.open();
                this.$refs.gameGrid.loadData();
            },
        },
        computed: {
            event() {
                return this.$store.getters['EventModule/getEvent'];
            },

            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            positionFTRegularColor() {
                return this.positionFTRegular > 0 ? '#6aa84f' : '#f6475d';
            },

            position1HRegularColor() {
                return this.position1HRegular > 0 ? '#6aa84f' : '#f6475d';
            },

            positionFTCornersColor() {
                return this.positionFTCorners > 0 ? '#6aa84f' : '#f6475d';
            },

            position1HCornersColor() {
                return this.position1HCorners > 0 ? '#6aa84f' : '#f6475d';
            },
        },
    };
</script>
